
jQuery(function($) {

  /******************************************/
    /********** VAR-----------/
  /******************************************/

  var LARGEUR_MAX_MOBILE = 800;
  var header = $("#masthead");
  var topMenuHeight = 120;
  var l_window_w = parseInt($(window).width());



   /* **************************************************  */
  /* NICSELECT MOBILE POUR SECTION SUR "LA CARTE" */
  /* **************************************************  */
  $('.to_nicedropdown-js').niceSelect();
  $('.js-special_sub_menu_mobile').on('change', function() {
     var href = this.value;
    scroll_to_section(href);
  });

 /*************/
    /* SUBMENU SCROLLING = ACTIVE + LINK TO SECTION // SIMPLEMENT POUR SINGLE ACTIVITY*/
    /*************/
  function scroll_to_section(href_dest){
    var variable = 20;
      //  if (href == "#realisations")  variable = 170;
    var offsetTop = href_dest === "#" ? 0 : $(href_dest).offset().top-topMenuHeight+1-variable;
    $('html, body').stop().animate({ 
        scrollTop: offsetTop
    }, 500);
  }


   /* **************************************************  */
  /* GALERY / IMG + LEGENCE DANS LA PAGE CARTE, UNIQUEMENT SUR MOBILE */
  /* **************************************************  */
  if ($(window).width() < 650) {
  var elements = document.getElementsByClassName('Products-Container');
  var i;
  for (i = 0; i < elements.length; i++) {
       lightGallery(elements[i], {
      // selector:'a',
       addClass: 'special_carte',
       selector:'.ProductItem',
       src: 'data-src',
       plugins: [lgThumbnail],
       subHtmlSelectorRelative: true,
       appendSubHtmlTo: '.lg-item',
       thumbnail: true,
       licenseKey:'9W2EW-JU49V-VEQJ5-QMMCD',
       productkey:'LhET',
       mobileSettings:{ controls: false, showCloseIcon: true, download: false}
    });
    elements[i].classList.add("lightGallery-on");
  }
}


  /******************************************/
    /********** SCROLL - NAV -----------/
  /******************************************/
 $(window).scroll(function () {
      action_on_scroll();
  });

  function action_on_scroll(){

     if ($(window).scrollTop() > 0){
        header.addClass("Masthead--sticky");
        $("body").addClass('header--sticky');
      }else{
         header.removeClass("Masthead--sticky");
        $("body").removeClass('header--sticky');
      }

   }

   //////// POPUP //////
  var overlay = $('#overlay');
  $( ".btnPopup--js" ).click(function() {
      openMoadl();
  });

  $( ".btn_close__modal___js" ).click(function() {
      closeMoadl();
  });

 
  function openMoadl() {
    $('body').addClass('open_modal');
    overlay.css('display', 'block');
    overlay.attr('aria-hidden', false);
     $('.overlay--innner').hide(0).fadeIn(300);
  }

  function closeMoadl(e) {
    // e.stopPropagation();
     overlay.attr('aria-hidden', true);
     $('.overlay--innner').fadeOut(300, 
        function(){  $('body').removeClass('open_modal'); overlay.css('display', 'none');}
      );
  }




  /* *****************  */
    /* SMOOTH SCROLL :  INTRO AUTRE PAGE  */
  /* *****************  */

    var linkbottomPage = $('.ToBottom-btn-page');
    var offsetTop;
     linkbottomPage.click(function(e){

    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top - 80 - 0;
  
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 600);
     
      e.preventDefault();
  });



  /* if in drawer mode */
  if(l_window_w < 767) $('.FooterContainer .js-Tabs-Inner-Content').hide();
  $(".js-Tabs-Inner-Title").click(function() {
       var parentActiveTab = $(this).parent().parent().attr('data-tabs-id');
      if($(this).next().css('display') == 'none'){
          $(parentActiveTab+" .js-Tabs-Inner-Content").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).fadeIn();
        
        $(parentActiveTab+" .js-Tabs-Inner-Title").removeClass("d_active");
          $(this).addClass("d_active");
        
        $(parentActiveTab+" .Tabs-Liste li").removeClass("active"); // inutile pour footer mais utile pour global tabs
        $(parentActiveTab+" .Tabs-Liste li[rel^='"+d_activeTab+"']").addClass("active");  // inutile pour footer mais utile pour global tabs
    }else{
      $(this).next().slideUp(400);
      $(parentActiveTab+" .js-Tabs-Inner-Title, .Tabs-Liste li").removeClass("d_active");  // inutile pour footer mais utile pour global tabs
    }
    });


  
   /* **************************************************  */
  /* GALERY DANS LES RETOUR EN IMAGE + GALERIE D'IMAGE */
  /* **************************************************  */
   lightGallery(document.getElementById('lightgallery'), {
      // selector:'a',
       selector:'a',
       plugins: [lgThumbnail],
       //subHtmlSelectorRelative: true,
       //appendSubHtmlTo: '.lg-item',
       thumbnail: true,
       licenseKey:'9W2EW-JU49V-VEQJ5-QMMCD',
       productkey:'LhET',
       mobileSettings:{ controls: false, showCloseIcon: true, download: false}
    });

  


/* ********************************************** */
/* **** SUB MENU SUR LA GAUCHE ************* */
/* ********************************************** */

       // Cache selectors
  var lastId,
      topMenu = $("#masthead"),
      $SubMenuLink = $("#sub_menu_aside"),
      // All list menuItems
      menuItems = $SubMenuLink.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) {return item;}
      });
   
 
  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function(e){
    var href = $(this).attr("href");
    var variable = 0;
        var offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1-variable;
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 500);
        
     
      e.preventDefault();
  });

    // Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop();
    
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
        variable_top = 10;
       if ($(this).offset().top - topMenuHeight - variable_top < fromTop)
       {

         return this;
       }
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "intro_carte";
      
     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         menuItems.removeClass("active");
         menuItems.filter("a[href='#"+id+"']").addClass("active");
     }else{
      // console.log('here' + id);
      // menuItems.filter("a[href='#section_1']").addClass("active");
     }                 
  });


  // ** //
  // AU RECHARGEMENT OU AU SCROLL DE LA PAGE = ON FAIT SCROLL SMOOTH VERS LA POSITION // 
  // ** // 
  function scroll_good_anchor(){
     if(window.location.hash) {
      var $hash_location = window.location.hash;
      if($($hash_location).length){
         var offsetTop = $hash_location === "#" ? 0 : $($hash_location).offset().top-topMenuHeight;
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 500);
      }
    } 
  }

  scroll_good_anchor();


/***********************************/
    /*** ANIMATION TXT + APPARITION + ON SCROLL ELT ****/
/***********************************/


  var $collection = $('.SectionInView');
$collection.each(function () {
   new Waypoint.Inview({
      element: this,
      enter: function(direction) {
        $(this.element).addClass('to_anim');
        // console.log(this.element.id + ' enter');
      },
      entered: function(direction) {
        // console.log(this.element.id + ' entered');
      },
      exit: function(direction) {
       
      },
      exited: function(direction) {
         $(this.element).removeClass('to_anim');
        // console.log(this.element.id + ' exited');
      }
   });
});


    /***********************************/
    /*** PIZZA DU MOMENT  ****/
/***********************************/





 $('.SlidePizzaMoment-js').slick({
            //setting-name: setting-value
          dots: true,
          arrows:false,
          draggable:true,
          autoplay: true,
          autoplaySpeed: 3500,
          pauseOnHover:false,
          pauseOnFocus:false,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed:1200,
         // fade: true, // a tester //
         // cssEase: 'ease-out',
          rows: 0,
           responsive: [
          {
            breakpoint: 701,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false,
              dots: true,
            }
          }
        ]  
    });















});
